export function setQueryParam(key, value, url = window.location.href, push = true) {
  const urlObj = new URL(url);
  urlObj.searchParams.set(key, value);
  const newUrl = urlObj.toString();
  if (push) window.history.pushState({}, '', newUrl);
  return newUrl;
}

export function getQueryParam(key, url = window.location.href) {
  return new URL(url).searchParams.get(key);
}
